exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".help-popover-text {\n  color: #005eb8;\n  cursor: pointer;\n}\n.sub-list li {\n  display: flex;\n}\n.sub-list li::before {\n  content: attr(data-index);\n  margin-right: 0.026042rem;\n}", ""]);

// exports
